// extracted by mini-css-extract-plugin
export default {"container":"Payroll_container__tqKXQ","body":"Payroll_body__2ZLft"};